import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppId, AppThunkAPIType } from "../../../app/appTypes"
import { deleteWithAuth, getWithAuth, putWithAuth } from "../../../http"

export interface MailTemplate {
    id: AppId,
    type: string,
    context: string,
    body: string,
    bodyEN: string,
    subject: string,
    subjectEN: string,
    footerId: string | null,
    companyId: number | null
    isFixed: boolean
}

export interface MailTemplatesFilter {
    context?: string
    companyId?: AppId
}

export interface ExtendedMailTemplate extends MailTemplate {
    originalId: AppId;
}

export type MailTemplatePayload = Omit<MailTemplate, "type" | "footerId" | "companyId" | "isFixed">

export const loadSuperMailTemplates = createAsyncThunk<MailTemplate[], MailTemplatesFilter | undefined, AppThunkAPIType>(
    "mailTemplates/load-for-super",
    async (filter, { dispatch, rejectWithValue }) => {
        const query = new URLSearchParams()
        if (filter?.context && filter.context !== "all") query.set("context", filter.context)
        if (filter?.companyId && filter.companyId !== "all") query.set("companyId", String(filter.companyId))
        const queryString = query.toString()
        const result = await dispatch(getWithAuth({ url: `api/sys/company-mail-templates${queryString ? '?' + queryString : ''}` }))
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as MailTemplate[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }

})

export const updateSuperMailTemplate = createAsyncThunk<MailTemplate, MailTemplatePayload, AppThunkAPIType>(
    "mailTemplate/edit-for-super",
    async (mailTemplates, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({ url: `api/sys/company-mail-templates/${mailTemplates.id}`, payload: mailTemplates }))
        const { payload } = result
        if (putWithAuth.fulfilled.match(result)) {
            return payload as MailTemplate
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const deleteSuperMailTemplate = createAsyncThunk<AppId, AppId, AppThunkAPIType>(
    "mailTemplate/delete-for-super",
    async (mailTemplateId, { rejectWithValue, dispatch }) => {
        const result = await dispatch(deleteWithAuth({ url: `api/sys/company-mail-templates/${mailTemplateId}` }))
        const { payload } = result
        if (deleteWithAuth.fulfilled.match(result)) {
            return mailTemplateId
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)